import type { BoxLabelGenerateSerialRow } from "@/pages/manufacturing/boxLabelGenerateApi";

/** Stable empty list — never allocate a fresh `[]` in render for missing serials. */
export const EMPTY_BOX_LABEL_LINE_SERIALS: readonly BoxLabelGenerateSerialRow[] = [];

export function boxLabelLineSerialsFromQuery(
  serials: readonly BoxLabelGenerateSerialRow[] | undefined,
): readonly BoxLabelGenerateSerialRow[] {
  if (serials == null || serials.length === 0) {
    return EMPTY_BOX_LABEL_LINE_SERIALS;
  }
  return serials;
}

export function boxLabelLineScopeKey(
  batchId: number | null,
  batchItemId: number | null,
): string | null {
  if (batchId == null || batchItemId == null) {
    return null;
  }
  return `${String(batchId)}|${String(batchItemId)}`;
}

/** Stable dependency for effects — ignores array identity churn from react-query refetches. */
export function boxLabelLineSerialsFingerprint(
  serials: readonly BoxLabelGenerateSerialRow[],
): string {
  if (serials.length === 0) return "";
  return serials.map((row) => row.device_label_serial).join("\u0000");
}

/** @deprecated Use {@link resolveBoxLabelPreviewDeviceSerial} */
export function pickBoxLabelPreviewDeviceSerial(
  current: string,
  serials: readonly BoxLabelGenerateSerialRow[],
): string {
  return resolveBoxLabelPreviewDeviceSerial(current, serials);
}

export function resolveBoxLabelPreviewDeviceSerial(
  preferredSerial: string,
  serials: readonly { device_label_serial: string }[],
): string {
  if (serials.length === 0) return "";
  const trimmed = preferredSerial.trim();
  if (trimmed !== "" && serials.some((row) => row.device_label_serial === trimmed)) {
    return trimmed;
  }
  return serials[0]!.device_label_serial;
}

export function boxLabelPreviewRequestKey(input: {
  batchId: number | null;
  batchItemId: number | null;
  deviceLabelSerial: string;
  printer: string;
}): string | null {
  if (input.batchId == null || input.batchItemId == null) return null;
  const serial = input.deviceLabelSerial.trim();
  const printer = input.printer.trim();
  if (serial === "" || printer === "") return null;
  return `${String(input.batchId)}|${String(input.batchItemId)}|${serial}|${printer}`;
}
